import type { FeatureFlag } from '@gonfalon/openapi/types';

export function getFlagVariationIndexFromId(variations: FeatureFlag['variations'], variationId: string) {
  return variations.findIndex((variation) => variation._id === variationId);
}
